export default __webpack_public_path__ + "static/media/front_squat.9088cca7.svg";